module.exports = __webpack_public_path__ + "img/folder-icon.c01a894c.png";